import { useMemo, useState } from 'react';

import styles from './QuizImageViewer.module.scss';
import { buildPdfStreamUrl } from '../../assets/utils/pdfViewerUrl';

export default function QuizImageViewer({ fileUrl, downloadUrl }) {
    const [loadError, setLoadError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const imageSrc = useMemo(
        () => buildPdfStreamUrl(downloadUrl || fileUrl),
        [downloadUrl, fileUrl],
    );

    const openUrl = imageSrc || downloadUrl || fileUrl;

    return (
        <div className={styles.wrap}>
            <div className={styles.toolbar}>
                <a
                    className={styles.toolBtnLink}
                    href={openUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    باز کردن در تب جدید
                </a>
                <a
                    className={styles.toolBtnLink}
                    href={openUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    دانلود تصویر
                </a>
            </div>

            <div className={styles.viewport}>
                {isLoading && !loadError ? (
                    <div className={styles.loading}>در حال بارگذاری تصویر…</div>
                ) : null}

                {loadError ? (
                    <div className={styles.error}>
                        {loadError}
                        {openUrl ? (
                            <>
                                <br />
                                <a href={openUrl} target="_blank" rel="noopener noreferrer">
                                    باز کردن یا دانلود تصویر
                                </a>
                            </>
                        ) : null}
                    </div>
                ) : null}

                {imageSrc ? (
                    <div className={styles.imageFrame}>
                        <img
                            src={imageSrc}
                            alt="سوالات آزمون"
                            className={styles.image}
                            onLoad={() => {
                                setIsLoading(false);
                                setLoadError(null);
                            }}
                            onError={() => {
                                setLoadError('بارگذاری تصویر سوالات ممکن نیست.');
                                setIsLoading(false);
                            }}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
}
